<template>
  <PopoverMenu
    :items="actionItems"
    trigger-icon="mdi:dots-horizontal"
    placement="bottom-right"
    :stay-open="false"
    class="data-table-action-dropdown"
  />
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import PopoverMenu from "@/components/ui/PopoverMenu.vue";
import { Icon } from "@iconify/vue";
import type { TableAction } from "./types";

interface Props<T = any> {
  row: T;
  actions: TableAction<T>[];
}

const props = defineProps<Props>();

const loadingAction = ref<string | null>(null);

const actionItems = computed(() => {
  return props.actions.map((action) => {
    const isLoading = loadingAction.value === action.label;
    return {
      label: action.label,
      icon: isLoading ? "mdi:loading" : typeof action.icon === "string" ? action.icon : undefined,
      onClick: async () => {
        loadingAction.value = action.label;
        try {
          await action.onClick(props.row);
        } finally {
          loadingAction.value = null;
        }
      },
      disabled: loadingAction.value !== null && !isLoading,
      danger: action.variant === "destructive",
    };
  });
});
</script>

<style scoped>
.data-table-action-dropdown {
  display: inline-flex;
}
</style>
